import { rootApi } from "../rootApi";

export const ordersApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // LIST
    getOrderList: builder.query({
      query: (params = {}) => {
        const p = new URLSearchParams(params);
        return { url: `v1/order/get-order-list?${p.toString()}`, method: "GET" };
      },
      transformResponse: (resp) => {
        const paged = resp?.data ?? resp;
        return {
          rows: paged?.rows ?? [],
          totalCount: paged?.totalCount ?? 0,
        };
      },
      providesTags: () => [{ type: "Orders", id: "LIST" }],
    }),

    // INVOICE -> PDF (blob)
    getInvoicePdf: builder.query({
      query: ({ vblen }) => ({
        url: `v1/order/getsapeinvoice?Vblen=${encodeURIComponent(vblen)}`,
        method: "GET",
        headers: { accept: "application/pdf" },
        // fetchBaseQuery için responseHandler ile binary çekiyoruz
        responseHandler: (response) => response.blob(),
      }),
      // sadece blob döndürüyoruz; dosya adını istersen meta.response.headers'tan çekebilirsin
      transformResponse: (blob /*, meta */) => blob,
    }),

     exportOrdersToExcel: builder.query({
      query: (params = {}) => {
        const p = new URLSearchParams(params);
        return { url: `v1/order/ExportToExcel?${p.toString()}`, method: "GET" };
      },
      transformResponse: (resp) => {
        const data = resp?.data ?? {};
        return {
          fileBase64: data.fileBase64,
          fileName: data.fileName,
          contentType: data.contentType,
          recordCount: data.recordCount,
          fileSize: data.fileSize,
        };
      },
    }),
  }),
  
});

export const { useGetOrderListQuery, useLazyGetInvoicePdfQuery, useLazyExportOrdersToExcelQuery } = ordersApi;
